import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=7fa8298c&lang=pug"
import script from "./Vendor.vue?vue&type=script&lang=js"
export * from "./Vendor.vue?vue&type=script&lang=js"
import style0 from "./Vendor.vue?vue&type=style&index=0&id=7fa8298c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoverlyIcon: require('/app/components/elements/typography/Icon.vue').default,LoverlyV2Heading: require('/app/components.v2/elements/Heading.vue').default,LoverlyV2Icon: require('/app/components.v2/elements/Icon.vue').default,LoverlyV2Button: require('/app/components.v2/elements/Button.vue').default,LoverlyV2ImageGrid: require('/app/components.v2/elements/image/Grid.vue').default,LoverlyV2Image: require('/app/components.v2/elements/image/Index.vue').default,LoverlyV2ContentBoxInfo: require('/app/components.v2/content/box/Info.vue').default,LoverlyV2ContentBoxTag: require('/app/components.v2/content/box/Tag.vue').default,LoverlyV2Video: require('/app/components.v2/elements/Video.vue').default,LoverlyV2ContentItemRealWedding: require('/app/components.v2/content/item/RealWedding.vue').default,LoverlyV2ContentItemVendor: require('/app/components.v2/content/item/Vendor.vue').default,LoverlyV2ContentList: require('/app/components.v2/content/List.vue').default,LoverlyV2SaveButton: require('/app/components.v2/elements/SaveButton.vue').default,LoverlyV2ModalVendorMessage: require('/app/components.v2/modal/vendor/Message.vue').default})
